import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { dollars } from 'utils/money';
import Typography from '@material-ui/core/Typography'
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { fetchApplications, createApplication, filterApplications } from 'actions/applications';
import Search from '@material-ui/icons/Search';
import Add from '@material-ui/icons/Add';
import EnhancedTable from '../Table';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  headerButton: {
    float: 'right'
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px',
    alignItems: 'center'
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  }
});

const colNames = [
  { id: 'number', type: 'string', label: 'Number' },
  { id: 'form.businessName', type: 'string', label: 'Company' },
  { id: 'status', type: 'string', label: 'Status' },
  { id: 'form.amount', type: 'number', label: 'Amount' },
  { id: 'lodgedAt', type: 'date', label: 'Lodgement Date' },
  { id: 'form.drawdownDate', type: 'date', label: 'Drawdown Date' },
  { id: 'application', type: 'string', label: 'Application' }
];

class List extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(fetchApplications({appType: 'referral', status: ['draft', 'lodged']}));
  };

  renderApplication = (application) => {
    const form = application.form
    return (
      <TableRow className={this.props.classes.row} key={application.number}>
        <TableCell>
          <Link to={`/leads/${application.number}`}>
            {application.number}
          </Link>
        </TableCell>
        <TableCell>
          {form.businessName}
        </TableCell>
        <TableCell>
          {application.status}
        </TableCell>
        <TableCell>
          {dollars(form.amount)}
        </TableCell>
        <TableCell>
          {application.lodgedAt && moment(application.lodgedAt).format('DD/MM/YYYY')}
        </TableCell>
        <TableCell>
          {moment(form.drawdownDate).format('DD/MM/YYYY')}
        </TableCell>
        <TableCell>
          { application.status === 'lodged' && <Link to={`/applications/${application.number}`}><Search /></Link> }
        </TableCell>
      </TableRow>
    );
  }

  handleCreate = () => {
    this.props.dispatch(createApplication({appType: 'referral', step: 'confirmation'}, (appNumber) => {this.props.history.push(`/leads/${appNumber}`)}));
  }

  handleSearch = (e) => {
    const term = e.target.value;
    this.props.dispatch(filterApplications({"form.businessName": term}));
  }

  renderHeading = () => {
    return (
      <div className={this.props.classes.heading}>
        <Typography variant='headline'>
          Leads
        </Typography>
        <div>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Search />
            </Grid>
            <Grid item>
              <TextField id="input-with-icon-grid" label="Company" onChange={(e)=>this.handleSearch(e)} />
            </Grid>
          </Grid>
        </div>
        <Button variant='raised' color='primary' onClick={this.handleCreate}>
          Create
          <Add />
        </Button>
      </div>
    );
  }

  render = () => {
    const { applications } = this.props;

    return (
      <EnhancedTable data={applications} renderHeading={this.renderHeading} renderRow={this.renderApplication} colNames={colNames}/>
    );
  };
}

const mapStateToProps = (state) => {
  let applications = state.applications && state.applications.list || [];
  if (state.applications.filtered && state.applications.filtered.length > 0) {
    applications = state.applications.filtered;
  }
  return { applications };
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Leads/List.js